module.exports = __webpack_public_path__ + "static/media/delivered-order.6def856e.svg";